"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetBigValue = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApWidgetBigValue = function (_a) {
    var className = _a.className, children = _a.children, size = _a.size, setElHeight = _a.setElHeight, height = _a.height, props = __rest(_a, ["className", "children", "size", "setElHeight", "height"]);
    var ref = React.useRef();
    React.useLayoutEffect(function () {
        if (setElHeight && ref && ref.current) {
            setElHeight(ref.current.clientHeight);
        }
    });
    return (React.createElement(styles_1.StyledWidgetBigValue, __assign({}, props, { ref: ref, size: size, height: height, className: "ap-widget-big-value" + (className ? " " + className : '') }), children));
};
//# sourceMappingURL=ApWidgetBigValue.js.map